import AppHelper from "../../helper";

export default {
    props: {
        id: {},
        label: {default: ''},
        name: {default: ''},
        value: {default: ''},
        placeHolder: {default: ''},
        mandatory: {type: Boolean,default: false},
        consent: {default: false},
        displayValue: {default: ''},
        isFloat: {type: Boolean, default: false},
        isCentered: {default: false},
        isActive: {default: false},
        size: {default: 'md'},
        maxLength: {default: false},
        numberLength: {default: false},
        type: {default: ''},
        readonly: {type: Boolean, default: false}
    },

    computed: {
        getSizeClass() {
            return 'form-control-' + this.size;
        },

        isLabelFloatActive() {
            if (!AppHelper.empty(this.value) && this.value.length > 0) {
                return true;
            }

            return false;
        },

        getValidators() {
            var validators = {}

            if (this.mandatory) {
                validators['required'] = true
            }

            if(this.numberLength){
                if(this.numberLength.nb_int > 0){
                    validators['max_value'] = Math.pow(10, this.numberLength.nb_int) - 1
                }

                if(this.numberLength.nb_decimal > 0){
                    validators['decimal'] = this.numberLength.nb_decimal
                }else{
                    validators['decimal'] = 0
                }
            }

            switch (this.type) {
                case 'email':
                    validators['email'] = true
                    break
                case 'url':
                    validators['url'] = true
                    break
                case 'phone':
                    validators['regex'] = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/
                    break
                case 'percentage':
                    validators['between'] = {min: 0, max: 100}
                    validators['decimal'] = 2
                    break
            }

            if(this.maxLength && !this.numberLength && this.type !== 'text'){
                validators['max'] = parseInt(this.maxLength)
            }

            return validators
        }
    },

    methods: {
      valueChanged() {
          this.$emit('value-changed', $event.target.value)
      }
    },

    inject: ['$validator'],
}
